import React, { useState } from "react";
import "./MaintenanceRequest.css";
import Axios from 'axios';
import { host, Host } from '../../App';
const MaintenanceForm = () => {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  var User = JSON.parse(window.localStorage.getItem("Name"));
  var token = (window.localStorage.getItem("acessToken"));


  const [formData, setFormData] = useState({
    Request_date: date,
    email: "",
    name: User,
    maintenance_category: "Facility",
    equipment_maintenance: "",
    facility_maintenance: "",
    issue_description: "",
    priority: "Low",
    tentative_completion_date: "",
    outside_assistance: "No",
    agency_name: "",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const print = () => {
    console.log(formData);
    Axios.post(`https://` + Host + `/api/add/MaintenanceRequest`, { Data: formData, token: token }).then((response) => {
      console.log(response.data);
      if (response.status === 200) {
        window.alert(response.data.message);
        window.location.reload(false);

      }
    })
      .catch(function (error) {
        console.log(error.response);
      });

  }
  return (
    <div class="Maintenance_request">
      <table className="table table-bordered" id="Purchase_table">
        <thead>
          <tr>
            <th scope="col" style={{ width: "30%" }}>FIELD</th>
            <th scope="col" style={{ width: "70%" }}>INPUT</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(formData).map(([key, value]) => (
            <tr key={key}>
              <td>{key.replace(/_/g, ' ').toUpperCase()}</td>
              <td>
                {key === "issue_description" || key === "comments" ? (
                  <textarea
                    className="form-control"
                    name={key}
                    rows="5"
                    style={{ width: "100%" }}
                    value={value}
                    onChange={handleChange}
                  />
                ) : key === "maintenance_category" || key === "priority" || key === "outside_assistance" ? (
                  <select
                    className="form-control"
                    name={key}
                    style={{ width: "100%" }}
                    value={value}
                    onChange={handleChange}
                  >
                    {key === "maintenance_category" && (
                      <>
                        <option value="General">Facility</option>
                        <option value="Equipment">Equipment</option>
                      </>
                    )}
                    {key === "priority" && (
                      <>
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                      </>
                    )}
                    {key === "outside_assistance" && (
                      <>
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </>
                    )}
                  </select>
                ) : (
                  <input
                    type={
                      key.includes("date") ? "date" :
                        key.includes("time") ? "datetime-local" :
                          key === "email" ? "email" : "text"
                    }
                    className="form-control"
                    name={key}
                    style={{ width: "100%" }}
                    value={value}
                    onChange={handleChange}
                  />
                )}
              </td>
            </tr>
          ))}
          <button class="btn btn-primary" onClick={print}>Submit</button>

        </tbody>
      </table>

    </div>

  );
};

export default MaintenanceForm;
